import React from 'react'

import Link from 'next/link'

import Logo from 'Components/Blocks/Logo'
import SocialLink from 'Components/Blocks/SocicalLink'
import { Column, Row, Text } from 'Components/UI'

import { SocialLinkKindId } from 'Constants/Ids'
import { HOME } from 'Constants/Paths'

import { useResponsiveLayout } from 'Hooks'

type Props = {
  secondary?: boolean
}

function Top({ secondary }: Props) {
  const { isWideDesktop } = useResponsiveLayout()

  return (
    <Column
      alignItems={[
        'center',
        'center',
        'center',
        'center',
        'center',
        'flex-start',
      ]}
      gap={6}
      width={secondary ? 'auto' : '320px'}
    >
      {secondary ? (
        <Logo tertiary width={317} />
      ) : (
        <Link href={HOME}>
          <Logo isClickable secondary width={220} />
        </Link>
      )}

      <Text center={!isWideDesktop} inverse medium screen14>
        Joining Emajin Golf Networking Club means you’ll be playing golf with
        incredible people, at some of the best golf courses in Australia
      </Text>

      {!secondary && (
        <Row gap={6}>
          <SocialLink kind={SocialLinkKindId.Facebook} />

          <SocialLink kind={SocialLinkKindId.Instagram} />

          <SocialLink kind={SocialLinkKindId.LinkedIn} />
        </Row>
      )}
    </Column>
  )
}

export default Top
